import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getName, redirectToHome, isProUser, getURLwithoutPro, isMintproApp, downloadFileMintpro, getQueryParamsFromString, clearUserCookies, downloadPdfFile, getEncryptedUserId } from '__utils/common-utils';
import { ENDPOINTS } from 'constants/endpoints';
import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import LoginSelector from 'views/login/login.selector';
import { getFormDataFromJson, fetchPost } from '__utils/ajax-wrapper';
import { AjaxError } from 'rxjs/ajax';
import { LayoutContext } from 'components/app-routes';
import { Row, Col } from 'antd';
import useFlashToggler from 'hooks/use-flash-toggler';
import './index.css';
import { PrimarySmallBtn } from 'components/button';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { COLOR } from 'constants/colors';
import PortfolioGrid from './portfolioGrid';
import emptyPortfolio from 'images/empty_portfolio.png';
import dashboardIllustration from 'images/dashboard_illustration.svg';
import whatsapp from "images/whatsapp.svg";
import { hideSharePopupAction, showSharePopupAction } from 'components/share/share.actions';
import { getAgentCode, getUserDetails } from '__utils/storage';
import { getFileServiceUrlFromFileId } from '../../__utils/common-utils';
import Footer from 'components/footer';
import MobileFooterLayout from 'components/old-footer-layout';
import FolioGraph from './folio-graph';
import elementVisibilty from '__utils/toggleVisibilty-util';
import { getEventName, Mixpanel } from '__utils/mixpanel';
import { fetchgetPortfolioDetails } from 'views/login/login.actions';
import { fetchCartDetailsSuccess } from 'views/cart/cart.actions';
import { ClickableSpan } from 'views/common-styled-components';



export const PortfolioContainer = styled.div<CommonStyledComponentProps>`
    margin-top: ${(props: any) => props.isMobile ? "16px" : "0"};
    border-radius: 8px;
    height: auto;
    overflow: auto;
    background-color: ${(props: any) => !props.isMobile ? `${COLOR.WHITE}` : `transparent`};
    margin-bottom: 60px;

    .valueText{
        font-size: ${(props: any) => props.isMobile ? `16px` : `18px`};
    }

    .summaryView {
        padding: ${(props: any) => props.isMobile ? `16px` : `40px 80px 0`};
        border-bottom: ${(props: any) => props.isMobile ? 'none' : '1px solid #dfeef5'};
        background: #fff;
        margin: ${(props: any) => props.isMobile ? "16px" : "0"}
    }
   
`;
const FolioGreyText = styled.div`
    font-size: ${(props: any) => props.isMobile ? `14px` : `16px`};
    color: ${COLOR.GREY}

`

const Portfolio: React.FC = () => {
    const dispatch = useDispatch();
    const flash = useFlashToggler();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const { portfolioDetails } = propsToJS(useSelector(LoginSelector));

    const { isDP } = getQueryParamsFromString(window?.location?.search);
    const majorStatus = sessionStorage.getItem('majorStatus') || '';

    useEffect(() => {
        SetLayoutProps({
            config: {
                title: getName() ? `${getName()}'s Account` : 'Account',
            }
        });
        !getUserDetails() && !majorStatus && elementVisibilty.show('loginDiv');
        if(!portfolioDetails || majorStatus) {
            dispatch(fetchgetPortfolioDetails(false,getEncryptedUserId()));
            if(majorStatus) {
                dispatch(fetchCartDetailsSuccess(null));
                clearUserCookies();
            }
        }
        Mixpanel.track(getEventName("isDP" ,"loaded","portfolio"), {
            agentCode: getAgentCode(),
            user: getUserDetails(),
            isDP: isDP == 'false' ? false : true
        });
    }, []);


    const FolioShareMsg = () => {
        return "Get a detailed view of your investments in the portfolio section in your account.You can login to your account on https://bit.ly/3pqU9JF";
    }

    const getPortfolioUrl = () => {
        return getURLwithoutPro(`/v1/profile/portfolio?agentCode=${getAgentCode()}`)
    }

    //@purpose: share via email/sms
    const shareFolioDetails = (shareTo: string, type: string, callBackFunc?: any) => {
        var dataToSend = {
            type: type,
            value: shareTo,
            clientName: getName() ?? 'Investor',
            encryptedId: getEncryptedUserId(),
            amountInvested: portfolioDetails?.netAmountInvested,
            currentValue: portfolioDetails?.netCurrentValue,
            returnAmount: portfolioDetails?.netReturnAmount,
            returnPercentage: portfolioDetails?.netReturnPercentage,
            date: portfolioDetails?.asOfNavDate,
        }
        const formData = getFormDataFromJson(dataToSend);

        fetchPost(
            `${ENDPOINTS.POST_SHARE_PORTFOLIO}`, formData, null, true
        ).then((response: any) => {
            if (response?.operationMessage === 'success' && response?.responseData) {
                const result = response?.responseData;
                dispatch(hideSharePopupAction());
                callBackFunc ? callBackFunc(result) : flash.success('Shared Portfolio successfully');
            }
            else {
                flash.error("Failed to share portfolio. Please try again later.");
                dispatch(hideSharePopupAction());
            }

        }, (error: AjaxError) => {
            flash.error("Failed to share portfolio. Please try again later.");
            dispatch(hideSharePopupAction());
        });
    }

    const onWhatsappShare = () => {
        shareFolioDetails('image', 'pdf/image', (result: any) => {
            if (isMobile && isMintproApp()) {
                const featurePayload = {
                    type: 'shareFileToWhatsapp',
                    payload: {
                        fileType: "image",
                        fileMeta: {
                            fileId: result.fileId,
                            fileName: result.fileName
                        },
                        intent: "WHATSAPP",
                        message: FolioShareMsg(),
                    },
                };
                window.postMessage(JSON.stringify(featurePayload), '*');
            }
            else {
                window.open(`https://api.whatsapp.com/send?text=` + window.encodeURIComponent(FolioShareMsg()), '_blank');
            }
        })
    }

    const onFolioDownload = () => {
        shareFolioDetails('pdf', 'pdf/image', (result: any) => {
            const url = getFileServiceUrlFromFileId(result.fileId);
            if (isMobile && isMintproApp()) {
                downloadFileMintpro(result.fileName, url, "application/pdf");
            } else {
                var link = document.createElement('a');
                link.href = url;
                link.target = "_blank"
                document.body.appendChild(link);
                link.click();
                link?.parentNode?.removeChild(link);
            }
        })
    }

    const shareConfig = {
        message: FolioShareMsg(),
        shareUrl: getPortfolioUrl(),
        onEmailOrSMSShare: shareFolioDetails,
        shareType: 'sharePortfolio',
        mixpanelData: { eventName: 'sharePortfolio', source: 'portfolio' },
        shareTitle: <p className='bold ft16'>Share Portfolio with customer</p>,
        customWhatsappShare: onWhatsappShare,
        showDownloadLink: true,
        hideCopyLink: true,
        onFileDownload: onFolioDownload
    }

    const onShareFolioClick = () => {
        dispatch(showSharePopupAction(shareConfig));
    }

    const getMajorStatusText = () =>{
        return (<p className='portfolio-block-text'>Your account is temporarily blocked as you have crossed the age of 18 years. Please reach out to <a style={{color: '#1890ff'}}>mfopsdesk@turtlemintmoney.com</a> or your advisor for further steps to unblock the account.You can also download the form for minor to major conversion through the given link - <ClickableSpan className='portfolioAnchorTxt' onClick={()=>downloadPdfFile('https://www.amfiindia.com/Themes/Theme1/downloads/MAMForm-forchangeinstatusfromMinortoMajor.pdf')}>Download</ClickableSpan></p>)
    }
    

    return <PortfolioContainer isMobile={isMobile}>
        {
            getUserDetails() || majorStatus ?
                portfolioDetails && portfolioDetails?.netAmountInvested > 0 ?
                    <div>
                        {!isMobile && <div className="accountTabsNav">
                            <p><span>PORTFOLIO OVERVIEW</span> (updated on {portfolioDetails.asOfNavDate})</p>
                        </div>}
                        <div className='summaryView'>
                            <Row gutter={48} style={{ flexDirection: isMobile ? 'column-reverse' : 'row' }}>
                                <Col xs={24} md={11}>
                                    <div>
                                        {!isMobile && (majorStatus ? getMajorStatusText() : <h3>{getName()?.split(" ")[0]}'s Dashboard </h3>)}
                                        {!majorStatus && <div className="f16" style={{ margin: '8px 0px 24px', color: '#757575' }}>
                                            {portfolioDetails?.netCurrentValue >= portfolioDetails?.netAmountInvested && <span>Your investments are well-positioned for continued growth. Keep up your regular contributions</span>}
                                            {portfolioDetails?.netCurrentValue < portfolioDetails?.netAmountInvested && <span>It appears your portfolio is currently navigating some challenges, but your investments are on track to meet your financial goals.</span>}
                                        </div>}
                                        <Row gutter={16} style={{ padding: '0 16px' }}>
                                            <Col xs={12}>
                                                <FolioGreyText>Invested Sum</FolioGreyText>
                                                <p className='valueText'> &#8377; {(portfolioDetails?.netAmountInvested)?.toLocaleString('en-IN')}</p>
                                            </Col>

                                            <Col xs={12}>
                                                <FolioGreyText>Current Value</FolioGreyText>
                                                <p className='valueText'> &#8377; {(portfolioDetails?.netCurrentValue)?.toLocaleString('en-IN')}</p>
                                            </Col>
                                        </Row>
                                        <div className="folioGreenBox">
                                            <Row gutter={16}>
                                                <Col xs={12}>
                                                    <div>
                                                        <FolioGreyText>Returns</FolioGreyText>
                                                        <p className={portfolioDetails.netCurrentValue >= portfolioDetails.netAmountInvested ? 'changesUp valueText' : 'changesDown valueText'}> {portfolioDetails.netCurrentValue >= portfolioDetails.netAmountInvested ? '+' : ''} {(portfolioDetails?.netReturnPercentage)?.toFixed(2)}%</p>
                                                    </div>
                                                </Col>

                                                <Col xs={12}>
                                                    <FolioGreyText>Profit / Loss</FolioGreyText>
                                                    <p className={portfolioDetails.netCurrentValue >= portfolioDetails.netAmountInvested ? 'changesUp valueText' : 'changesDown valueText'}> &#8377; {(portfolioDetails?.netReturnAmount)?.toLocaleString('en-IN')}</p>
                                                </Col>
                                            </Row>
                                        </div>
                                        {isProUser() && 
                                        <div className="mt24 portfolioShare" onClick={onShareFolioClick} >
                                            <img src={whatsapp} alt="whatsapp" />
                                            <span>Share Investment Statement</span>
                                        </div>}
                                    </div>
                                </Col>
                                <Col xs={24} md={13}>
                                    {isMobile && (majorStatus ? getMajorStatusText() : <h3>{getName()?.split(" ")[0]}'s Dashboard </h3>)}
                                    <img src={dashboardIllustration} alt="dashboard" width='100%' className='mb48'></img>
                                </Col>
                            </Row>

                        </div>
                        <div className={`summaryBar ${isMobile ? 'box-shadow-common' : ''}`}>
                            <FolioGraph />
                        </div>
                        <div>
                            <h3 className='portfolioHead'>PORTFOLIO DETAILS</h3>
                            <PortfolioGrid />
                        </div>
                    </div>
                    : <section className="noMsgBoxInner accContent CurrentHolding">
                        <div className="noMsgBox">
                            <img src={emptyPortfolio} alt="empty" />
                            <h2>Your portfolio is being rebuilt with latest NAV!</h2>
                            <h4>Please check in some time.</h4>
                            {/* <h2>You don't have any holdings yet.</h2>
                            { majorStatus ? getMajorStatusText():<PrimarySmallBtn onClick={() => redirectToHome()}>click here to start investing</PrimarySmallBtn> } */}
                        </div>
                    </section>
                : null
        }

        {isMobile &&
            <Footer>
                <MobileFooterLayout />
            </Footer>
        }

    </PortfolioContainer>;
}

export default Portfolio;
